import FlashOnIcon from '@material-ui/icons/FlashOn';
import React from 'react';

import { HazardCategoryDefinitionControllerService } from 'api/client';
import { HazardCategoryDefinitionDto } from 'api/client';

import BaseDefinitionPage from '../../BaseDefinitionPage';
import HazardCategoryDefinitionForm from './Forms/HazardCategoryDefinitionForm';

export default function HazardCategoryDefinition() {
  return (
    <BaseDefinitionPage<HazardCategoryDefinitionDto>
      listLabelPropName="label"
      fetchData={HazardCategoryDefinitionControllerService.getAllHazardCategoryDefinitions}
      FormDialog={HazardCategoryDefinitionForm}
      onDelete={HazardCategoryDefinitionControllerService.deleteAllHazardCategoryDefinitions}
      Icon={<FlashOnIcon />}
      searchName="label"
    />
  );
}
